import { Link } from "react-router-dom";
const HomeYoga = () => {
  return <section className="w-full bg-gradient-to-b from-white via-[#f8f5f1] to-white py-16 sm:py-20 lg:py-28">
            <div className="container mx-auto px-4">
                {
    /* Mobile Layout - sm and below */
  }
                <div className="lg:hidden flex flex-col gap-8">
                    {
    /* Label */
  }
                    <p className="text-sm font-semibold uppercase tracking-[0.35em] text-amber-800">
                        Yoga
                    </p>
                    <h2 className="font-serif text-2xl font-light leading-tight tracking-tight text-[#1f4d3c] sm:text-3xl">
                        Sich selbst und der Welt wieder näher kommen.
                    </h2>

                    {
    /* Image */
  }
                    <div className="relative h-[280px] overflow-hidden sm:h-[380px]">
                        <img
    src="/images/Hiru/front_yoga_teaser.webp"
    alt="Yoga-Illustration"className="object-contain" style={{ position: "absolute", inset: 0, width: "100%", height: "100%" }} loading="lazy" />
                    </div>

                    {
    /* Content */
  }
                    <div>


                        <p className="mt-6 text-base font-semibold leading-relaxed text-[#1f4d3c] sm:text-lg">
                            Hiru Resort – ein Yoga-Urlaub, den man nur hier erleben kann.
                        </p>

                        <div className="mt-5 space-y-4 text-[15px] leading-relaxed text-gray-700 sm:text-base">
                            <p>
                                Ergänzt durch tägliche, sorgfältige Behandlungen des Therapieteams, finden regelmäßig Yogastunden statt, bei denen Sie Zeit für Ihre innere Mitte finden. Die Kurse werden in einer ruhigen Yoga-Pavillon-Konstruktion auf einer Anhöhe mit Blick auf den Indischen Ozean unterrichtet – geleitet von erfahrenen Instructoren.
                            </p>
                            <p>
                                Durch sanfte Asanas, verschiedene Pranayama-Techniken und tiefe Entspannung entsteht ein Gefühl von innerem Frieden, ähnlich wie eine ruhige Seeoberfläche. Dadurch gewinnen Sie wieder ein stärkeres Gefühl der Verbindung zu sich selbst und zur reichen Natur rundherum.
                            </p>
                            <p>
                                Bereits bei Ihrer Ankunft sind spezielle Yogamatten für unsere Gäste vorbereitet. Bringen Sie einfach entspannte Kleidung mit und genießen Sie auf der von der Sonne erwärmten Matte wertvolle Zeit für sich selbst.
                            </p>
                        </div>

                        <div className="mt-8">
                            <Link
    to="/activities"
    className="inline-flex items-center justify-center rounded-full bg-[#F28600] px-6 py-2.5 text-sm font-semibold text-white shadow-lg shadow-[#f28600]/25 transition hover:bg-[#d67000]"
  >
                                Mehr erfahren
                            </Link>
                        </div>
                    </div>
                </div>

                {
    /* Desktop Layout - lg and above */
  }
                <div className="hidden lg:flex flex-col gap-10 lg:flex-row lg:items-center lg:gap-16">
                    <div className="lg:w-7/12">
                        <p className="mb-4 text-sm font-semibold uppercase tracking-[0.35em] text-amber-800">
                            Yoga
                        </p>

                        <h2 className="font-serif text-3xl font-light leading-tight tracking-tight text-[#1f4d3c] sm:text-4xl lg:text-5xl">
                            Sich selbst und der Welt wieder näher kommen.
                        </h2>

                        <p className="mt-8 text-lg font-semibold leading-relaxed text-[#1f4d3c]">
                            Hiru Resort – ein Yoga-Urlaub, den man nur hier erleben kann.
                        </p>

                        <div className="mt-6 space-y-5 text-[17px] leading-relaxed text-gray-700 lg:text-lg">
                            <p>
                                Ergänzt durch tägliche, sorgfältige Behandlungen des Therapieteams, finden regelmäßig Yogastunden statt, bei denen Sie Zeit für Ihre innere Mitte finden. Die Kurse werden in einer ruhigen Yoga-Pavillon-Konstruktion auf einer Anhöhe mit Blick auf den Indischen Ozean unterrichtet – geleitet von erfahrenen Instructoren.
                            </p>
                            <p>
                                Durch sanfte Asanas, verschiedene Pranayama-Techniken und tiefe Entspannung entsteht ein Gefühl von innerem Frieden, ähnlich wie eine ruhige Seeoberfläche. Dadurch gewinnen Sie wieder ein stärkeres Gefühl der Verbindung zu sich selbst und zur reichen Natur rundherum.
                            </p>
                            <p>
                                Bereits bei Ihrer Ankunft sind spezielle Yogamatten für unsere Gäste vorbereitet. Bringen Sie einfach entspannte Kleidung mit und genießen Sie auf der von der Sonne erwärmten Matte wertvolle Zeit für sich selbst.
                            </p>
                        </div>

                        <div className="mt-10">
                            <Link
    to="/activities"
    className="inline-flex items-center justify-center rounded-full bg-[#F28600] px-7 py-3 text-sm font-semibold text-white shadow-lg shadow-[#f28600]/25 transition hover:bg-[#d67000]"
  >
                                Mehr über Yoga erfahren
                            </Link>
                        </div>
                    </div>

                    <div className="lg:w-5/12">
                        <div className="relative h-[320px] overflow-hidden sm:h-[420px] lg:h-[560px]">
                            <img
    src="/images/Hiru/front_yoga_teaser.webp"
    alt="Yoga-Illustration"className="object-contain" style={{ position: "absolute", inset: 0, width: "100%", height: "100%" }} loading="lazy" />
                        </div>
                    </div>
                </div>
            </div>
        </section>;
};
export default HomeYoga;
